import { Text } from "@chakra-ui/react";

export const SegmentAllRestrictionsWarning = () => (
  <Text as="span" fontSize="xs" lineHeight={1.5}>
    Instead of using the <strong>All</strong> segment select{" "}
    <strong>Everyone</strong> from the access mode.
  </Text>
);

export const SegmentStatelessRestrictionsWarning = () => (
  <Text as="span" fontSize="xs" lineHeight={1.5}>
    Segments with <strong>First seen</strong>, <strong>Last seen</strong> or{" "}
    <strong>Flag metric</strong> filters are not supported for access rules.
  </Text>
);
